// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCategories } from "@awc/App/Services/CategoryService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { RequestDataFromApi, chain } from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";

export const AwcRequestDataFromApi: typeof RequestDataFromApi = async props => {
    try {
        const result = await getCategories(props.apiParameter);
        props.apiResult = result.categoryCollection;
        // XNG-Change
        props.dispatch({ type: "xHeader/setCategories", categories: result.model.categories } as any);

    } catch (error) {
        if (error?.status === 404) {
            if (props.apiParameter.startCategoryId) {
                props.dispatch({
                    type: "Data/Categories/FailedToLoadCategory",
                    categoryId: props.apiParameter.startCategoryId,
                    status: error.status,
                });
            }
            return false;
        }
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, AwcRequestDataFromApi);
